import React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Button, FormBoxCompat, InformationModal } from "@impero-com/ui";
import Checkbox from "antd/es/checkbox";
import { ControllerRenderProps, useController, useForm } from "react-hook-form";

import { ExportFormSchema } from "./schema";

interface CheckboxFieldProps {
    field: ControllerRenderProps<ExportFormSchema, any>;
    children: React.ReactNode;
}

function CheckboxFieldInner({ field, children }: CheckboxFieldProps) {
    return (
        <FormBoxCompat>
            <Checkbox
                // eslint-disable-next-line react-hooks/refs
                ref={field.ref}
                // eslint-disable-next-line react-hooks/refs
                checked={field.value}
                // eslint-disable-next-line react-hooks/refs
                onChange={field.onChange}
            >
                {children}
            </Checkbox>
        </FormBoxCompat>
    );
}

const CheckboxField = React.forwardRef((props: CheckboxFieldProps, _ref) => {
    return (
        <CheckboxFieldInner field={props.field}>
            {props.children}
        </CheckboxFieldInner>
    );
});

function ExportPopup(props: ExportPopupProps) {
    const { control, handleSubmit } = useForm<ExportFormSchema>({});

    const onSubmit = handleSubmit((data) => {
        props.onConfirm(props.selectedIds, data, props.onCancel);
    }, undefined);

    const { field: includeAssignments } = useController({
        control,
        name: "includeAssignments",
    });

    return (
        <InformationModal
            open
            onClose={props.onCancel}
            type="info"
            icon="export"
            title={props.title}
            footer={
                <>
                    <Button onClick={props.onCancel}>{t("Cancel")}</Button>
                    <Button variant="primary" onClick={() => void onSubmit()}>
                        {t("Export")}
                    </Button>
                </>
            }
        >
            <p>
                {t("Controls_Export_Confirmation_Text", {
                    count: props.selectedIds.length,
                })}
            </p>
            <CheckboxField field={includeAssignments}>
                {t("Controls_Export_Include_Assignments")}
            </CheckboxField>
        </InformationModal>
    );
}

interface ExportPopupProps {
    selectedIds: Array<string>;
    title: string;
    onConfirm: (
        selectedIds: string[],
        form: ExportFormSchema,
        done: () => void
    ) => void;
    onCancel: () => void;
}

export { ExportPopup, type ExportPopupProps };
